import React from 'react'
import { GiGraduateCap, GiFloorHatch, GiSwordSmithing, GiScrollUnfurled } from 'react-icons/gi'

export function getHighlightedItemClass(highlightedIndex, index) {
  if (highlightedIndex === index) {
    return 'bg-[color:var(--xstyled-colors-doc-search-suggestion-highlight-background)]'
  }
  return ''
}

const typeToIcon = {
  tutorial: GiGraduateCap,
  changelog: GiFloorHatch,
  page: GiSwordSmithing,
  glossary: GiScrollUnfurled,
}

export default function Result({ item, index, getItemProps, highlightedIndex }) {
  const IconComponent = typeToIcon[item.resultType] || typeToIcon['page']
  return (
    <li
      {...getItemProps({ item, index })}
      className={`px-4 py-2 md:p-4 bg-opacity-50 ${getHighlightedItemClass(
        highlightedIndex,
        index
      )}`}
    >
      <div className="flex flex-wrap flex-row items-center">
        <IconComponent className="hidden w-5 h-5 mr-4 md:block"></IconComponent>
        <div className="flex-1 flex-row flex-nowrap truncate">
          <div className="font-display font-bold">{item.title}</div>
          <div className="font-body truncate">{item.description}</div>
        </div>
      </div>
    </li>
  )
}
